import { Injectable } from '@angular/core'
import { filterNilValue, QueryEntity } from '@datorama/akita'
import { Observable } from 'rxjs'
import { filter, map } from 'rxjs/operators'
import { Filter, Project, ProjectDetails } from './project.model'
import { ProjectsStore, ProjectsState } from './projects.store'

@Injectable({ providedIn: 'root' })
export class ProjectsQuery extends QueryEntity<ProjectsState, Project> {
  selectFilter$ = this.select(state => state.ui.filter)

  selectSearchQuery$ = this.select(state => state.ui.searchQuery)

  selectProjectsToSkip$ = this.select(state => state.ui.skipProjects)

  selectHasMoreProjects$ = this.select(state => !!state.ui.hasMoreItems)

  canSave$ = this.select(state => state.ui.projectFormState.isModified && state.ui.projectFormState.isValid)

  isModified$ = this.select(state => state.ui.projectFormState.isModified)

  get isModified() {
    return this.getValue().ui.projectFormState.isModified
  }

  get isValid() {
    return this.getValue().ui.projectFormState.isValid
  }

  get filter(): Filter {
    return this.getValue().ui.filter
  }

  get searchQuery(): string {
    return this.getValue().ui.searchQuery
  }

  constructor(protected store: ProjectsStore) {
    super(store)
  }

  hasProject(id: string): boolean {
    return this.hasEntity(id) && !!this.getEntity(id).projectDetails
  }

  selectProject(id: string): Observable<ProjectDetails> {
    return this.selectEntity(id).pipe(
      filterNilValue(),
      filter(({ projectDetails }) => !!projectDetails),
      map(p => p.projectDetails),
    )
  }
}
